import { GET_BILLING_STATUS_ASYNC, TENANT_TYPE } from 'containers/Agents/constants'
import { SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC } from 'containers/CustomizedAutoSync/constants'
import { AS_GD_ASYNC, AS_O365_ASYNC } from 'containers/Mailboxes/constants'
import { THEMIS_ANALYSIS_ASYNC } from 'containers/ResolutionCenter/Report/constants'
import {
  QUICK_INTEGRATION_CONTINUE,
  QUICK_INTEGRATION_SAVE_ASYNC,
} from 'containers/Settings/EmailServer/QuickIntegration/constants'

import {
  DISMISS_DISCOVERY_BANNER,
  FETCH_DEMO_MODE_BANNER_ASYNC,
  FETCH_DISCOVERY_BANNER_ASYNC,
  HIDE_DISCOVERY_BANNER,
} from './constants'

const initialState = {
  showDemoBanner: false,
  mailboxesSyncing: false,
  error: null,
  discoveryBanner: { showBanner: false, reason: null },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEMO_MODE_BANNER_ASYNC.SUCCESS:
      return {
        ...state,
        error: null,
        showDemoBanner: action.payload.data.showDemoBanner,
      }
    case FETCH_DEMO_MODE_BANNER_ASYNC.ERROR:
      return { ...state, error: action.error }
    // Discovery banner — `action.payload` is the raw GET response.
    case FETCH_DISCOVERY_BANNER_ASYNC.SUCCESS:
      return {
        ...state,
        discoveryBanner: {
          showBanner: Boolean(action.payload?.showDiscoveryBanner),
          reason: action.payload?.reason ?? null,
        },
      }
    // Keep last-known visibility. CombinedBanner re-fetches on every pathname
    // change (IC-49444); Incidents Status lands via Redirect onto unclassified,
    // so two INITIATEs fire back-to-back and switchMap aborts the first GET.
    // Treating that abort as "hide" blanks the banner for ~one RTT until the
    // surviving GET succeeds. A confirmed hide only comes from SUCCESS / the
    // live-hide actions below.
    case FETCH_DISCOVERY_BANNER_ASYNC.ERROR:
      return { ...state, error: action.error }
    // X button only (IC-49457: "Try it now" must NOT dismiss) — hide optimistically;
    // the epic persists the session dismissal.
    case DISMISS_DISCOVERY_BANNER:
      return { ...state, discoveryBanner: { showBanner: false, reason: 'session_dismissed' } }
    // Live permanent hide (PLG Experience §1.1) — no page refresh needed. The
    // backend GET remains the source of truth on the next load.
    case HIDE_DISCOVERY_BANNER:
      return {
        ...state,
        discoveryBanner: { showBanner: false, reason: action.payload?.reason ?? null },
      }
    // Preview credits ran out (billing/status fetch, or a 402 from the streaming
    // endpoint) — the banner must disappear for everyone without a refresh. The
    // backend GET decides it server-side off the same plg_remaining value; this
    // keeps the live session in sync.
    // Only PLG exhaustion hides the banner. billing/status always includes a
    // plgCredits object (remaining: 0 for PAYG and for unprovisioned CM tenants);
    // the discovery-banner GET fails open for those same tenants, so treating
    // remaining === 0 alone would hide the banner the moment Settings → AI Credits
    // fetches billing status.
    case GET_BILLING_STATUS_ASYNC.SUCCESS:
      if (
        action.payload?.tenantType === TENANT_TYPE.PLG &&
        action.payload?.plgCredits?.remaining === 0 &&
        state.discoveryBanner.showBanner
      ) {
        return { ...state, discoveryBanner: { showBanner: false, reason: 'no_credits' } }
      }
      return state
    case THEMIS_ANALYSIS_ASYNC.ERROR:
      if (action.error === 'Insufficient credits' && state.discoveryBanner.showBanner) {
        return { ...state, discoveryBanner: { showBanner: false, reason: 'no_credits' } }
      }
      return state
    case AS_O365_ASYNC.SUCCESS:
    case AS_GD_ASYNC.SUCCESS:
    case AS_O365_ASYNC.INITIATE:
    case SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.SUCCESS:
    case QUICK_INTEGRATION_SAVE_ASYNC.SUCCESS:
    case QUICK_INTEGRATION_CONTINUE:
      return { ...state, mailboxesSyncing: true }
    default:
      return state
  }
}
